import React from "react";
import Actions from "okpay/actions/Actions";

class CloseButton extends React.Component {
	_onClickClose = () => {
		Actions.close();
	};

	render() {
		return (
			<button className="okpay-close" onClick={this._onClickClose}>
				<i className="okicon i-close" />
			</button>
		);
	}
}

export default CloseButton;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/CloseButton.jsx